// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const UserIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "User/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3 18a7 7 0 1 1 14 0H3Z"
}));
export default UserIcon;